export var MINIMUM_INPUT_LENGTH = 3;
/** API Endpoints */

export var LOCATION_DROPDOWN_ENDPOINT = "/location";
export var INITIAL_LOCATION_ENDPOINT = "/user-location";
export var SET_LOCATION_ENDPOINT = "/set-user-location";
/** Error texts */

export var DROPDOWN_DATA_FETCH_ERROR = "Oops, an error occurred while looking for your location. Please try again.";
export var DROPDOWN_INVALID_INPUT_ERROR = "Please enter a valid postcode or suburb.";
export var SET_LOCATION_ERROR = "Oops, an error occurred while setting your location. Please try again.";